import Vue from 'vue';
import _ from 'lodash';
import {
    GET_STORE_CHARGE_CARD_LIST_REQUEST,
    GET_STORE_CHARGE_CARD_LIST_SUCCESS,
    GET_STORE_CHARGE_CARD_LIST_FAILURE,
    STORE_CHARGE_CARD_LIST_ITEM_EDIT
} from '../mutationTypes';

const state = {
    cardLoading: false,
    introduction: '本店储值卡简介',  // v2.7:本店储值卡简介
    cardList: [], // 充值套餐列表
    editId: '',

};
const mutations = {
    [GET_STORE_CHARGE_CARD_LIST_REQUEST](state) {
        state.cardLoading = true;
    },
    [GET_STORE_CHARGE_CARD_LIST_SUCCESS](state, res) {
        state.cardLoading = false;
        // v2.7
        state.introduction = res.introduction;
        state.cardList = _.filter(res.list, (item) => {
            if (item.charge === '') {
                state.editId = item.id;
            }
            return !!item.charge;
        });
        // state.cardList
        state.cardList.push(_.find(res.list, item => item.charge === ''));
    },
    [GET_STORE_CHARGE_CARD_LIST_FAILURE](state) {
        state.cardLoading = false;
    },
    [STORE_CHARGE_CARD_LIST_ITEM_EDIT](state, payload) {
        const { id, k, val } = payload;

        if (!id) return;

        const index = _.findIndex(state.cardList, item => item.id === id);

        state.cardList[index][k] = val;
    }
};

export const actions = {
    async getStoreChargeCards({ commit }) {
        commit(GET_STORE_CHARGE_CARD_LIST_REQUEST);

        const res = await Vue.$ajax.get('pcChargeCardList');

        if (!res.errorType) {
            commit(GET_STORE_CHARGE_CARD_LIST_SUCCESS, res);
        } else {
            commit(GET_STORE_CHARGE_CARD_LIST_FAILURE);
        }
    },
    editStoreChargeCardItem({ commit }, payload) {
        commit(STORE_CHARGE_CARD_LIST_ITEM_EDIT, payload);
    }
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/prePaidEdit.js